module.exports = __webpack_public_path__ + "img/rex.1737ae2a.png";